<template>
  <div class="account-file-upload">
    <div style="display: flex;justify-content: space-between">
      <account-title :title="serialNo + '、' + title+checkTitle"></account-title>
      <!-- <div class="material-selection">点击上传</div> -->
    </div>
    <div class="account-file-upload-content">{{ content }}</div>
    <div class="account-file-upload-wrapper">
      <div
        class="account-file-upload-preview"
        v-for="(item, index) of list"
        :key="index"
      >
        <!-- <div @click.stop="downLoadFile(item,index)"> -->
        <div >
          <van-image
            width="55"
            height="55"
            class="pdf-icon"
            :src="item.FJURL || item.fileUrl"
          />
          <van-icon
            class="delete-icon"
            :name="require('@/assets/img/projectAppoint/delete.png')"
            v-if="isEdit"
            @click="deleteFile(item, index)"
          ></van-icon>
        </div>
      </div>
      <van-uploader
        :after-read="onAfterRead"
        :before-read="onBeforeRead"
        max-count="1"
        accept=""
        id="android-upload"
        v-if="isEdit"
      >
        <van-button class="upload-btn">
          <van-icon name="plus" size="40" color="#DDDDDD"
        /></van-button>
      </van-uploader>
    </div>
    <!-- <appoint-material
      ref="AppointMaterial"
      :title="title"
      @confirm="materialConfirm"
    ></appoint-material> -->
  </div>
</template>

<script>
import AccountTitle from "../PersonalCenter/account-title.vue";
// import AppointMaterial from "../ProjectAppoint/appoint-material.vue";
import api from "@/utils/api/appoint";
import { mapGetters } from "vuex";
import clonedeep from 'lodash.clonedeep'
export default {
  components: { AccountTitle },
  props: {
    title: {// 标题
      type: String,
      default: "",
    },
    value: {// 值
      type: Array,
      default: () => {
        return [];
      },
    },
    isCheck: {
      type: Boolean,
      default: false,
    },
    serialNo: {// 序号
      type: Number,
    },
    content: {// 内容
      type: String,
      default: "",
    },
    isEdit: {// 是否可编辑
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      accept: ".pdf",
      listValue: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters("form", ["getFormConfigByName"]),
    checkTitle() {
      return this.isCheck?'（必需）':'（非必需）'
    }
  },
  methods: {
    // 文件读取前的回调函数
    onBeforeRead(file) {
      // console.log(file)
      // 黑名单文件判断(固定9种类型)
      if (/.(jsp|jspx|jspf|sh|html|htm|shtml|js|htaccess)$/i.test(file.name)) {
        this.$toast("文件类型不支持");
        return false;
      }
      // 文件类型判断(由后台配置传入)
      // if (this.accept && this.accept != '*') {
      //   const nameArr = file.name.split('.')
      //   const type = '.' + nameArr[nameArr.length - 1]
      //   if (!this.accept.includes(type)) {
      //     this.$toast('文件类型不匹配')
      //     return false
      //   }
      // }
      this.$emit("onBeforeRead", file);
      return true;
    },
    // 文件读取后的回调函数
    onAfterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (!(file instanceof Array)) {
        this.upload(file);
      } else {
        file.forEach((item) => {
          this.upload(item);
        });
      }
      this.$emit("onAfterRead", file);
    },
    // 上传处理
    upload(file) {
      const params = new FormData();
      console.log("file", file);
      let data = {
        fileName: file.file.name,
        fileSize: this.getSize(file.file.size),
        fileIcon: this.getType(file.file.name),
        fileStatus: 0,
        fileComplete: 0,
        fileUrl: "",
      };
      this.list.push(data);
      console.log("list", this.list);
      params.append("file", file.file);

      // this.$set(data, 'fileComplete', '10')
      // this.$set(data, 'fileStatus', 1)
      api
        .materialUpload(params, (progressEvent) => {
          let complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          this.$set(data, "fileComplete", complete);
          console.log("上传 " + complete);
        })
        .then((res) => {
          const dataRes = res.data[0];

          if (dataRes) {
            let fileData = {
              FJNAME: dataRes.fileName,
              FJURL: dataRes.fileUrl,
            };
            console.log("--res", res);
            this.$set(data, "fileStatus", 1);
            this.$set(data, "fileUrl", dataRes.fileUrl);
            this.listValue.push(fileData);
            this.$emit("input", this.listValue);
          }
        });
    },
    // 下载文件
    downLoadFile(item,index){
      //文件
      console.log("item:",item);
      const params = this.UrlParamHash(item.FJURL)
      console.log('params', params)
      let url =
        'macroPath=' +
        params['macroPath'] +
        '&fileName=' +
        decodeURI(params['fileName'])

      console.log("downLoadFile url:",url);
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateTo({
          url: '/pages/downloadFile/downloadFile?' + url
        })
      } else {
        this.$toast.fail('请使用小程序下载')
      }
    },
    // 删除上传文件
    deleteFile(item, index) {
      this.list.splice(index, 1);
      this.listValue.splice(index,1)
      this.$emit("input", this.listValue);
    },
    // 计算文件大小
    getSize(fileSize) {
      let size = "";
      if (fileSize < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = fileSize.toFixed(2) + "B";
      } else if (fileSize < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (fileSize / 1024).toFixed(2) + "KB";
      } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (fileSize / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }

      const sizeStr = size + ""; // 转成字符串
      const index = sizeStr.indexOf("."); // 获取小数点处的索引
      const dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou == "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
    // 获取文件类型
    getType(fileType) {
      let type = fileType.split(".")[fileType.split(".").length - 1];
      if (
        type == "png" ||
        type == "jpg" ||
        type == "jpeg" ||
        type == "svg" ||
        type == "gif"
      ) {
        type = require("@/assets/img/projectAppoint/jpg_png.png");
      } else if (type == "rar" || type == "zip" || type == "7z") {
        type = require("@/assets/img/projectAppoint/zip_rar_7z.png");
      } else if (type == "pdf") {
        type = require("@/assets/img/projectAppoint/pdf.png");
      } else {
        type = require("@/assets/img/projectAppoint/jpg_png.png");
      }
      return type;
    },
    UrlParamHash(url) {
      var params = [],
        h
      var hash = url.slice(url.indexOf('?') + 1).split('&')
      //  console.log(hash)
      for (var i = 0; i < hash.length; i++) {
        h = hash[i].split('=') //
        params[h[0]] = h[1]
        //   console.log(h)
      }
      return params
    },
    // 
    materialConfirm(data) {
      data.forEach((item) => {
        let flag = false;
        this.listValue.forEach((element) => {
          if (element.FJNAME == item.FJNAME && element.FJURL == item.FJURL) {
            flag = true;
          }
        });
        if (!flag) {
          let listData = {
            fileName: item.FJNAME,
            fileIcon: this.getType(item.FJNAME),
            fileStatus: 1,
            fileComplete: 0,
            fileUrl: item.FJURL,
          };
          console.log(this.list,this.listValue)
          this.list.push(listData);
          this.listValue.push(item);
        }
      });
      this.$emit("input", this.listValue);
      console.log("materialConfirm", data);
    },
  },
  created() {
    //初始化
    this.listValue = clonedeep(this.value)
    this.list = clonedeep(this.value)
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.account-file-upload {
  .material-selection {
    font-size: 14px;
    font-weight: 500;
    color: #1d84ff;
  }
  .account-file-upload-content {
    font-size: 11px;
    font-weight: 500;
    color: #999999;
    margin-bottom: 12px;
  }
  .account-file-upload-wrapper {
    display: flex;
    flex-wrap: wrap;
    .account-file-upload-preview {
      width: 55px;
      height: 55px;
      margin-right: 20px;
      position: relative;
      border: 1px solid #dddddd;
      text-align: center;
      .delete-icon {
        position: absolute;
        top: 0;
        right: 0;
        -webkit-transform: translate(50%, -50%);
        transform: translate(50%, -50%);
        width: 14px;
        height: 14px;
      }
      .pdf-icon {
        width: 28px;
        height: 100%;
      }
    }
  }
  .upload-btn {
    width: 55px;
    height: 55px;
  }
}
</style>
